/*
===============================================================================
    File        =   ikimy-website-app/src/pages/Recruiter/Recruiter.js
    Client      =   Rhealize
    Project     =   Ikimy Platform
    Purpose     =   Landing page for the Recruiter
                    
===============================================================================
    Revision History
        -----------------------------------------------------------------------
        Version Date        Author              Comments
        -----------------------------------------------------------------------
        1.0     2025.03.12  Daniel Rashidian    Initial Creation
        -----------------------------------------------------------------------
===============================================================================
*/
// react
import { useMediaQuery } from 'react-responsive'
// components
import DesktopRecruiter from "./DesktopRecruiter";
import MobileRecruiter from "./MobileRecruiter";

// ui-components

const Recruiter = () => {
    const isPortrait = useMediaQuery({ query: '(max-width: 768px)' })

    return (
        <>
            { isPortrait && <MobileRecruiter /> }
            { !isPortrait && <DesktopRecruiter /> }
        </>        
    )
};

export default Recruiter;